import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './bell.svg'


const _hoisted_1 = ["alt"]

import { getFollowedProductIds } from "../../followed-products";
//import { toggleFollowProduct } from ".";
import { loginPopup } from "../../../../../../legacy/loginPopup";
import labels from "../../../../shared/labels";
import axios from "axios";


export default /*@__PURE__*/_defineComponent({
  __name: 'follow-button',
  props: {
    productId: {
        type: Number,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const followingProductIds = getFollowedProductIds();

async function toggleFollowProduct(productId: number) {
    const response = await axios.post<{
        Subscribed: 0 | 1;
        Success: 0 | 1;
    }>(`/auctionProduct/ToggleSubscribeProduct/${productId}`);
    if (response.data.Success !== 1) {
        throw new Error("Failed");
    }
    return response.data.Subscribed == 1;
}

async function toggleFollow() {
    if (window.isAuthenticated() !== true) {
        loginPopup();
        return;
    }
    if (props.productId == null) throw new Error("no id");
    const following = await toggleFollowProduct(props.productId);

    if (following) {
        if (
            followingProductIds.value != null &&
            followingProductIds.value.includes(props.productId) == false
        )
            followingProductIds.value.push(props.productId);
    } else {
        if (followingProductIds.value?.includes(props.productId) == true)
            followingProductIds.value.splice(
                followingProductIds.value.indexOf(props.productId),
                1
            );
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: _imports_0,
    class: _normalizeClass({
            'bell-image': true,
            'follow-btn': true,
            following:
                __props.productId != null && _unref(followingProductIds)?.includes(__props.productId),
        }),
    alt: _unref(labels).frontendProductpage.subscription.sub,
    width: "21",
    height: "20",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggleFollow()), ["stop","prevent"]))
  }, null, 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})